export default __webpack_public_path__ + "static/telemed-link_2-ce4d09ba83aa08c11d35eb5f968b946e.jpg";